import React from "react";

var bgimg1 = require("./../../images/background/bg-5.png");
var bgimg2 =
  "https://www.terreoceane.com/wp-content/uploads/2018/01/salon_Helia-670x417.jpg";
var bgimg3 = require("./../../images/background/cross-line2.png");

class WhatWeDo6 extends React.Component {
  render() {
    return (
      <>
        <div
          className="section-full  mobile-page-padding bg-white  p-t80 p-b30 bg-repeat overflow-hide"
          //   style={{ backgroundImage: "url(" + bgimg1 + ")" }}
        >
          <div className="container right-half-bg-image-outer">
            <div
              className="right-half-bg-image bg-parallax bg-fixed bg-top-right"
              data-stellar-background-ratio={0}
              style={{ backgroundImage: "url(" + bgimg2 + ")" }}
            />
            {/* TITLE START */}
            <div className="section-head">
              <div className="sx-separator-outer separator-left">
                <div
                  className="sx-separator bg-white bg-moving bg-repeat-x"
                  //   style={{ backgroundImage: "url(" + bgimg3 + ")" }}
                >
                  <h3 className="sep-line-one">Nous Rejoindre</h3>
                </div>
              </div>
            </div>
            {/* TITLE END */}
            <div className="section-content">
              <div className="row number-block-one-outer justify-content-center">
                <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                  <div className="number-block-one animate-in-to-top">
                    <ul className="m-l50">
                      <li>
                        Acceptation de votre demande d’adhésion par le Conseil
                        d’Administration de l’association ;
                      </li>
                      <li>
                        Respect des clauses du statut et du règlement interne de
                        l’association.
                      </li>
                      <li>Paiement des droits d’adhésion dans les délais ;</li>
                      <li>Respect des délais de paiement des échéances.</li>
                    </ul>
                    <div className="figcaption bg-white text-center p-a20">
                      <h4 className="m-a0"> Conditions d’adhésion</h4>
                    </div>
                    <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                      <span>01</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                  <div className="number-block-one animate-in-to-top">
                    <ul className="m-l50">
                      <li>Demande d’adhésion ;</li>
                      <li>Fiche de renseignement dument renseignée ;</li>
                      <li>Engagement légalisé ;</li>
                      <li>Copie CIN ;</li>
                      <li>
                        Attestation de travail ou tout autre document précisant
                        la profession ;
                      </li>
                      <li>
                        Reçu de virement/versement de la première tranche
                        d’adhésion au compte bancaire de l’association.
                      </li>
                    </ul>
                    <div className="figcaption bg-white text-center p-a20">
                      <h4 className="m-a0"> Dossier d’adhésion</h4>
                    </div>
                    <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                      <span>02</span>
                    </div>
                  </div>
                </div>
                <div className="col-lg-4 col-md-6 col-sm-6 m-b30">
                  <div className="number-block-one animate-in-to-top">
                    <ul className="m-l50">
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/documentation/#"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">Statut ALV</strong>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/documentation/#"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">
                            Règlement Intérieur
                          </strong>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/wp-content/uploads/2013/09/5-Fiche-de-renseignement.pdf"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">
                            Fiche de renseignement
                          </strong>
                        </a>
                      </li>
                      <li>
                        <a
                          target="_blank"
                          href={
                            "https://associationlavallee.com/wp-content/uploads/2013/09/6-Engagement.pdf"
                          }
                          className="btn-block"
                        >
                          <span
                            style={{ fontSize: "20px" }}
                            className="text-red m-r10"
                          >
                            <i className="fa fa-file-pdf-o" />
                          </span>
                          <strong className="  text-black">Engagement</strong>
                        </a>
                      </li>
                    </ul>
                    <div className="figcaption bg-white text-center p-a20">
                      <h4 className="m-a0">Documentations</h4>
                    </div>
                    <div className="figcaption-number text-center sx-text-primary animate-in-to-top-content">
                      <span>03</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default WhatWeDo6;
